<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import CountDown from "@/components/checkout/CountDown.vue";
import DefaultVideoComponent from "@/components/centre/DefaultVideoComponent.vue";

export default {
  name: "ThankYou",
  page: {
    title: "Thank You",
    meta: [{ name: "description", content: "Thank You Page." }],
  },
  components: {
    Header,
    Footer,
    CountDown,
    DefaultVideoComponent,
  },
  props: {
    isUpgrade: {
      type: Boolean,
      default: false,
    },
    isNextLevelCustomer: {
      type: Boolean,
      default: false,
    },
    nextAction: {
      type: Object,
      default() {
        return {
          message: "add info to your invoices",
          route: { name: "CentreMyAccount", params: { page: "Billing" } },
        };
      },
    },
    boughtOnlyAromaEmpress: {
      type: Boolean,
      default: false,
    },
    hasSubscription: {
      type: Boolean,
      default: false,
    },
    originUrl: {
      type: String,
      default: "/",
    },
    price: {
      type: Number,
      default: 1900,
    },
    vat: {
      type: Number,
      default: 418,
    },
    country: {
      type: String,
      default: "United States",
    },
    currency: {
      type: String,
      default: "EUR",
    },
    period: {
      type: String,
      default: "Monthly",
    },
  },
  data() {
    return {
      defaultDate: new Date(),
      offerAvailableMinutes: 1440, //24 * 60 = 24h hours
      giftValue: 250,
    }
  },
  computed: {
    accountAction: function () {
      if (this.isUpgrade) {
        return "upgraded";
      } else {
        return "created";
      }
    },
    isCheckoutURLFromSmartBlending() {
      // const originUrlSource = this.originUrl.includes('SmartBlending')
      // console.log('originUrlSource: ' + originUrlSource);
      // console.log('isURLSourceSmartBlending: ' + this.originUrl.includes('SmartBlending'));
      return this.originUrl.includes('SmartBlending');
    },
    expirationDateComputed() {
      // console.log("expirationDateComputed.Default date : " + this.defaultDate.toUTCString());
      this.defaultDate.setMinutes(this.defaultDate.getMinutes() + this.offerAvailableMinutes);
      // console.log("expirationDateComputed.Default date (doppo di aggiungere il 15 minuti) : " + this.defaultDate.toUTCString());
      return this.defaultDate.getTime();
    },    
  },
  mounted: function () {
    // console.log("Is upgrade? " + this.isUpgrade);
    // console.log("Is Next Level customer? " + this.isNextLevelCustomer);
    // console.log("originUrl: " + this.originUrl);
    // console.log("in mounted block - default date: " + this.defaultDate.toUTCString());
    this.logPurchaseOnFacebookPixel();
  },
  methods: {
    doNextAction() {
      if("path" in this.nextAction && this.nextAction.path) {
        window.location = this.nextAction.path;
      } else {
        this.$router.push(this.nextAction.route);
      }
    },
    buttonToTheNextLevelPage() {
      // console.log('Redirecting to the Next Level Page');
      var url = "https://courses.melanimethod.com/nextleveloffer?p=fWKSDljer62mHdfkelru7r43mIfjq76QWiOpnHeyuf&dt=" + Math.trunc(this.defaultDate.getTime() / 1000);
      window.open(url, "_blank");
    },
    logPurchaseOnFacebookPixel() {
      
      let totalInDecimals = (this.price / 100).toFixed(2);
      let vatInDecimals = (this.vat / 100).toFixed(2);

      let netValue = (totalInDecimals - vatInDecimals).toFixed(2);

      // console.log('this.price: ' + this.price);
      // console.log('totalInDecimals: ' + totalInDecimals);
      // console.log('this.vatInDecimals: ' + vatInDecimals);
      // console.log('this.netValue: ' + netValue);
      // console.log('this.currency: ' + this.currency);
      // console.log('this.period: ' + this.period);
      // console.log('this.originUrl: ' + this.originUrl);
      // console.log('this.country: ' + this.country);

      fbq('track', 'Purchase', {
        country: this.country,
        currency: this.currency,
        value: totalInDecimals,
        vatAmount: vatInDecimals,
        neto: netValue,
        content_name: this.period,
        source: this.originUrl,
      });
    },
  },
};
</script>
<template>
  <main class="thank-you">
    <Header />
    <div class="container text-center content-thank" v-if="!isCheckoutURLFromSmartBlending">
      <img src="../assets/images/icon-thank-you.png" alt />
      <h1>
        Account <span>{{ accountAction }}</span>
      </h1>

      <div v-if="!this.isNextLevelCustomer">

        <h2 v-if="this.hasSubscription">
          Congratulations! Your account has been successfully <strong>{{ accountAction }}</strong>.
          <br />We sent you a welcome email with all the details. Thank you!
        </h2>

        <h2 v-if="!this.hasSubscription">
          Congratulations! You enrolled in the course. 
          <br />
          We sent you a welcome email with further instructions on how to access the content.
        </h2>
      </div>

      <div v-if="this.isNextLevelCustomer">
        <h2 v-if="this.hasSubscription">
          Congratulations! You are enrolled in the Next Level Power Drops
          Program.
          <br />We sent you a welcome email with more details about the program,
          <br />plus additional information on how to use your Dropsmart Premium
          Account right away.
        </h2>

        <h2 v-if="!this.hasSubscription">
          Congratulations! You enrolled in the course. 
          <br />
          We sent you a welcome email with further instructions on how to access the content.
        </h2>
      </div>

      <!-- Show this div ONLY if the customer DID NOT buy the Early Bird for Real Recipes  -->
      <div class="upsell-card" v-if="boughtOnlyAromaEmpress">
        <p style="color: #e00b11; font-weight: 700; font-size: 38px;">Early Bird for Real Recipes</p>
        <p style="padding-left: 3rem; padding-bottom: 0; letter-spacing: 0.05rem; font-weight: 500; color: #293847; font-size: 22px;">
        <span style="color: #68AC55; font-weight: 900;">IMPORTANT:</span> You are reading this message because this is an UNIQUE opportunity that will not be available for this price any more.</p>
        <!-- Show this button twice: once after the red title and once again after the texts -->
        <b-button class="ds-action-button ds-action-button-main" @click="doNextAction()">{{nextAction.message}}</b-button>
        <p style="padding: 0 3rem; letter-spacing: 0.05rem; font-weight: 500; color: #293847; font-size: 22px;">
          In this course that will be launched in January 2022, Melani will explain in details case studies and their <b>REAL RECIPES!</b> You will get to know why these recipes worked or didn't work, and you will find out how to use essential oil chemistry to create efficient blends.
          Don't miss the opportunity to co-create this course with Melani and get your questions explained.
        </p>
        <p style="padding: 1rem 3rem; letter-spacing: 0.05rem; font-weight: 500; color: #293847; font-size: 28px;">
          The ultimate course that will give you the credibility you need by understanding what formulating really is.
        </p>
        <p style="padding: 1rem 3rem; letter-spacing: 0.05rem; font-weight: 500; color: #293847; font-size: 22px;">
          Secure your spot for this excellent price now. Today is the ONLY chance you will have to get it for this price. 
          Plus, you can split your payment in 10x.
        </p>
        <p style="padding: 1rem 3rem; letter-spacing: 0.05rem; font-weight: 500; color: #293847; font-size: 22px;">
          The price now is <span style="color: #68AC55; font-weight: 900;">ONLY € 747 (or $ 847)</span>. Please, don't lose it. This is your last chance at this price!
        </p>        
        <b-button style="margin-top: 1rem;" class="ds-action-button ds-action-button-main" @click="doNextAction()">{{nextAction.message}}</b-button>
      </div>

      <div>
        <b-button class="ds-action-button" @click="doNextAction()">add info to your invoices</b-button>
      </div>

    </div>

    <!-- If the client came from /joinsmartblending or /smartblending URLs, upsell the Next Level Power Drops Program -->
    <div class="upsell-card" v-if="isCheckoutURLFromSmartBlending">
      <div class="container text-center content-thank">
        <img src="../assets/images/icon-thank-you.png" alt />
        <!--h1>
          Account <span>{{ accountAction }}</span>
        </h1-->
        <p class="paragraph">
          <strong>Congratulations. Your account was {{ accountAction }}.</strong>
          <!--br/>Your Dropsmart account is Premium now.
          <br/>Plus, you're enrolled into the SMART Blending Program.
          -->
        </p>
      </div>
      <DefaultVideoComponent videoUrl="https://player.vimeo.com/video/913738467" />
      <b-button class="ds-action-button ds-action-button-main" @click="buttonToTheNextLevelPage">Click here to claim your gift</b-button>
      <CountDown :expirationDate="expirationDateComputed" :showTitleBlock="false"/>
    </div>

    <Footer />
  </main>
</template>
<style lang="scss">
html,
body,
#app {
  height: 100%;
  overflow-x: hidden;
}
.thank-you {
  background-image: url("../assets/images/img-vectors-thankyou.png");
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  .logo img {
    max-width: 236px;
    width: 100%;
  }
}
.container {
  .row {
    min-height: 175px;
  }
  h1 {
    font-size: 36px;
    color: #000000;
    font-weight: 700;
    margin-top: 20px;
    text-transform: uppercase;
  }
  h2 {
    color: #000000;
    font-size: 22px;
    line-height: 34px;
    margin-top: 30px;
    span {
      color: #499f30;
      text-transform: capitalize;
    }
  }
}
.content-thank {
  padding: 2% 0;
}
.navbar-global-header {
  font-size: 16px;
  padding: 0 !important;
  justify-content: flex-end !important;
  li {
    align-self: center;
  }
  a {
    color: #000000 !important;
    line-height: 42px;
    padding: 0 25px !important;
    &:hover {
      color: #79b867 !important;
    }
  }
}
.tryfree a {
  background: #79b867;
  border: 2px solid #79b867;
  border-radius: 30px;
  color: #ffffff !important;
  font-weight: 700;
  line-height: 42px;
  margin: 0 15px;
  padding: 0 40px !important;
  &:hover {
    background: #000000;
    border-color: #000000;
    color: #ffffff !important;
  }
}
.ds-action-button {
  background: #79b867;
  border: 1px solid #79b867;
  border-radius: 50px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 53px;
  padding: 0 15px;
  text-transform: uppercase;
  min-width: 30ch;
  max-width: 100ch;
  .spinner-border {
    vertical-align: middle;
  }
  &:hover {
    background: #000000;
    border-color: #000000;
    color: #ffffff;
  }
  &:focus {
    outline: none;
  }
}
.ds-action-button-main {
  margin: 30px;
  background: #E00B11;
  border: 1px solid #E00B11;
  &:hover {
    background: #79b867;
    border-color: #79b867;
    color: #ffffff;
  }
  &:focus {
    outline: none;
  }
}

.upsell-card {
  background-color: #fffcf4;
  border: 1px dashed red;
  border-radius: 4px;
  max-width: 1000px;
  margin-top: 3rem;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: left;
  padding: 3rem;
}

.paragraph {
  font-size: 1.7rem;
  margin: 1.3rem;
  padding-left: 3rem; 
  padding-bottom: 0; 
  letter-spacing: 0.05rem; 
  font-weight: 500; 
  color: #293847; 
}

@media (min-width: 992px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg {
    .row {
      max-width: 1230px !important;
    }
  }
}
@media screen and (max-width: 1139px) {
  .container {
    .row {
      min-height: 110px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 18px;
    }
  }
  .hide-small {
    display: none;
  }
}
@media screen and (min-width: 1140px) {
  .hide-lg {
    display: none;
  }
}
@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    .row {
      max-width: 1230px !important;
    }
  }
}
</style>